<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table"><slot></slot></h3>
    </div>
    <div class="ly-sort ly-sort-his">
      <span class="count">
        {{ $t("messages.all")
        }}<span class="count-num">{{ tableData.length }}</span
        >{{ $t("messages.unit") }}
      </span>
    </div>
    <div class="scroll-x">
      <idc-list
        :height="344"
        :tableHeader="tableHeader"
        :tableData="tableData"
        @clickRow="stepRowClick"
      />
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";

export default {
  components: { IdcList },
  props: {
    exeWflowId: {
      type: String,
      default: "",
    },
  },
  watch: {
    exeWflowId() {
      if (this.exeWflowId != "") {
        this.searchStepWrkProgrList(this.exeWflowId, 0);
      } else {
        this.tableData = [];
      }
    },
  },
  data() {
    return {
      tableHeader: [
        { prop: "rn", label: "NO", width: "5" },
        { prop: "stepCdHnglNm", label: this.$t("messages.lblStepNm"), width: "6" },
        { prop: "stepSttusNm", label: this.$t("messages.lblWorkStatus"), width: "6.5" },
        { prop: "ticktAsgnDt", label: this.$t("messages.lblWorkStartDate"), width: "12.5" },
        { prop: "ticktFnsDt", label: this.$t("messages.lblWorkCompleteHoldDate"), width: "12.5" },
      ],
      tableData: [],
    };
  },
  created() {
    this.$EventBus.$on("reloadStepHist", (data) => {
      this.searchStepWrkProgrList(this.exeWflowId, data.stepCd);
    });
  },
  mounted() {
    this.searchStepWrkProgrList(this.exeWflowId, 0);
  },
  methods: {
    searchStepWrkProgrList(exeWflowId, stepCd) {
      if (exeWflowId == null || exeWflowId == "") {
        this.tableData = [];
        return;
      }

      this.$BIZ_SERVICE
        .post(this.$API_URLS.Svc.getWflowInstStepPgst, {
          exeWflowId: exeWflowId,
          stepCd: stepCd,
        })
        .then((res) => {
          this.tableData = res.data.resData.map((data, index) => {
            data.rn = index + 1;

            if (data.stepSttus === "WAIT") {
              data.stepSttusNm = this.$t("messages.lblWait");
            } else if (data.stepSttus === "HLD") {
              data.stepSttusNm = this.$t("messages.lblPendding");
            } else if (data.stepSttus === "RCESS") {
              data.stepSttusNm = this.$t("messages.lblRcess");
            } else if (data.stepSttus === "PROGR") {
              data.stepSttusNm = this.$t("messages.lblProgress");
            } else {
              data.stepSttusNm = this.$t("messages.lblComplete");
            }
            return data;
          });
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
        })
        .finally(() => {
          this.$EventBus.$emit("reloadDtlStepHist", { stepCd: stepCd });
        });
    },
    stepRowClick(col, row) {
      this.$EventBus.$emit("reloadDtlStepHist", { stepCd: row.stepCd });
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-x {
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    &-thumb {
      width: 3px;
      height: 3px;
      background-color: $--text-disabled;
      border-radius: $--border-radius-base;
    }
  }
}
.el-table {
  min-width: 1400px;
}
</style>
